import React, { Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import { ScriptService } from '../../../controllers/ScriptService';
import { HeaderDisplayType, HeaderInteractionType } from '../../../interfaces';
import Header from '../../../views/app/Header';
import StickyHeader from '../../../views/app/StickyHeader';
import Loading from '../../loading/loading';
import PlayerControlRow from '../UI/PlayerControls/PlayerControlsRow';
import '../styles/player-style.scss';

interface PlayerLoadingSpinnerProps {
  image?: string;
}

export function PlayerLoadingSpinner({ image }: PlayerLoadingSpinnerProps) {
  const history = useHistory();
  const position = 0;
  return (
    <div className="ats-player">
      <StickyHeader overPlayer={true} />
      <Header
        displayType={HeaderDisplayType.Player}
        interactionType={HeaderInteractionType.Back}
        closeCallback={() => {
          history.goBack();
        }}
      />
      <Loading classNames={{ container: 'ats-player-loading' }} size={82} contained />
      {image !== undefined && <img className="banner" src={image} alt="loading" />}

      <PlayerControlRow
        volumeControl={<Fragment />}
        streamQualityMenu={<Fragment />}
        audioAndSubtitlesMenu={<Fragment />}
        isPlaying={false}
        isWatchingLive={false}
        playPause={() => void 0}
        fastForward={() => void 0}
        rewind={() => void 0}
        isFullscreen={ScriptService.isFullscreen()}
        fullscreen={() => void 0}
        airplay={() => void 0}
        playNextEpisode={() => void 0}
        togglePictureInPicture={() => void 0}
        currentProgram={undefined}
      />

      <div className="player-controls-wrapper">
        <div className="player-controls">
          <div className="player-control-row range-row">
            <style type="text/css">
              {'input[type=range].player-seekbar::-webkit-slider-runnable-track { ' +
                'border-radius: 2px;' +
                'background-image: -webkit-gradient(linear, left top, right top, color-stop(' +
                (1 - position - 1) +
                ', #FFFFFF), color-stop(' +
                (1 - position - 1) +
                ', #5a5958)) !important; }' +
                'input[type=range]::-moz-range-track { border-radius: 2px; background: linear-gradient(to right, #FFFFFF, #FFFFFF ' +
                (100 * (1 - position) - 100) +
                '%, #5a5958 ' +
                (100 * (1 - position) - 100) +
                '%)!important; }'}
            </style>

            <input
              name="slider"
              className="player-control-item player-seekbar"
              type="range"
              step="1"
              value={0}
              max={9999}
              min={0}
              onChange={() => void 0}
            />
            <div className="player-control-item range-text end-time-text">00:00:00</div>
          </div>
        </div>
      </div>
    </div>
  );
}
